import usePromotionsCardStyles from './PromotionsCard.styles';
import { IPromoCardProps } from './PromotionsCard.types';

const PromotionsCard = (props: IPromoCardProps) => {
    const styles = usePromotionsCardStyles();

    const { title, subTitle, description, dueMonthly, dueToday } = props;

    return (
        <div className={styles.root}>
            <div className={styles.contentWrapper}>
                <div>
                    <div className={styles.promoTitle}>{title}</div>

                    <div className={styles.subTitle}>{subTitle}</div>

                    <div className={styles.description}>{description}</div>
                </div>

                <div className={styles.amountDueValues}>
                    {dueMonthly ? (
                        <div className={styles.valueWrapper}>
                            <div className={styles.discountAmount}>{dueMonthly}</div>
                            {props.valueSubText && (
                                <div className={styles.valueSubtext}>{props.valueSubText}</div>
                            )}
                        </div>
                    ) : (
                        <div className={styles.discountAmount}>--</div>
                    )}

                    {dueToday ? (
                        <div className={styles.valueWrapper}>
                            <div className={styles.discountAmount}>{dueToday}</div>
                            {props.valueSubText && (
                                <div className={styles.valueSubtext}>{props.valueSubText}</div>
                            )}
                        </div>
                    ) : (
                        <div className={styles.discountAmount}>--</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PromotionsCard;
